import { Dispatch, SetStateAction } from 'react'

import { BehaviorLogSearchCondition } from '@/common/api/modules/behaviorLog'
import {
  ListFollowTableHeaderProps,
  makeRectPropsForTableHeadItem,
  useListScrollFollow
} from '@/common/app/list'
import { BehaviorLog } from '@/common/model/recommend/behavior'

import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import BehaviorListRow from '@/components/container/modules/recommend/behavior/table/BehaviorListRow'
import ScrollFollowTable from '@/components/container/utils/list/ScrollFollowTable'

const COLUMNS = [
  'イベント日時',
  'アクション',
  'クッキーID',
  'セッションID',
  '顧客ID',
  '商品ID',
  'カテゴリID',
  'デバイス',
  'ブラウザ',
  '滞在時間',
  'ページURL',
  'リファラー'
]

interface TheadProps extends ListFollowTableHeaderProps {
  float?: boolean
}

const Thead = ({ float = false, rowRefs, rowRects }: TheadProps) => {
  const rectProps = (index: number) =>
    makeRectPropsForTableHeadItem(rowRefs, rowRects, index, float)

  return (
    <>
      {COLUMNS.map((col, i) => (
        <TableHeadItem key={col} float={float} {...rectProps(i)}>
          <Text size={12} color={TextColor.SECONDARY}>{col}</Text>
        </TableHeadItem>
      ))}
    </>
  )
}

interface Props {
  logs: BehaviorLog[]
  total: number
  condition: BehaviorLogSearchCondition
  setCondition: Dispatch<SetStateAction<BehaviorLogSearchCondition>>
  onUpdatePage: (page: number) => void
}

const BEHAVIOR_COLUMN_LENGTH = 12

const BehaviorListTable = ({ logs, total, condition, onUpdatePage }: Props) => {
  const listFollowProps = useListScrollFollow(BEHAVIOR_COLUMN_LENGTH)
  const { header } = listFollowProps

  const theadProps: TheadProps = { ...header }

  return (
    <ScrollFollowTable
      listFollowProps={listFollowProps}
      tableHead={<Thead {...theadProps} />}
      tableFloatHead={<Thead {...theadProps} float />}
      body={
        <>
          {logs.map((log) => (
            <BehaviorListRow key={log.id} log={log} />
          ))}
        </>
      }
      condition={condition}
      onUpdatePage={onUpdatePage}
      total={total}
    />
  )
}

export default BehaviorListTable
